// // dashboard-fronted/src/components/AdminReportRecipients.jsx
// import React, { useEffect, useState } from 'react';
// import { fetchJSON } from '../api';

// const AdminReportRecipients = () => {
//   const [recipients, setRecipients] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // Form states
//   const [email, setEmail] = useState('');
//   const [frequency, setFrequency] = useState('weekly');
//   const [formats, setFormats] = useState([]); 
//   // e.g. user can pick multiple: csv, pdf, xlsx
  
//   // Editing states
//   const [editId, setEditId] = useState(null); // the _id of the recipient being edited
  
//   const fetchRecipients = async () => {
//     try {
//       const data = await fetchJSON('/api/report-recipients');
//       setRecipients(data);
//     } catch (err) {
//       console.error('Error fetching recipients:', err);
//       alert('Failed to fetch recipients');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // On component mount, fetch the recipients
//   useEffect(() => {
//     fetchRecipients();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const payload = {
//         email,
//         frequency,
//         formats
//       };
      
//       if (editId) {
//         // Update existing recipient
//         await fetchJSON(`/api/report-recipients/${editId}`, {
//           method: 'PUT',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload)
//         });
//         alert('Recipient updated successfully');
//       } else {
//         // Create new recipient
//         await fetchJSON('/api/report-recipients', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload)
//         });
//         alert('Recipient added successfully');
//       }
      
//       setEmail('');
//       setFrequency('weekly');
//       setFormats([]);
//       setEditId(null);
//       fetchRecipients(); // Refresh the list
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this recipient?')) return;
//     try {
//       await fetchJSON(`/api/report-recipients/${id}`, {
//         method: 'DELETE'
//       });
//       alert('Recipient removed');
//       fetchRecipients();
//     } catch (err) {
//       alert(err.message);
//     }
//   };

//   const handleEditClick = (recipient) => {
//     setEditId(recipient._id);
//     setEmail(recipient.email);
//     setFrequency(recipient.frequency);
//     setFormats(recipient.formats || []);
//   };

//   // Toggle a format in the formats array
//   const handleFormatChange = (format) => {
//     if (formats.includes(format)) {
//       // remove it
//       setFormats(formats.filter(f => f !== format));
//     } else {
//       // add it
//       setFormats([...formats, format]);
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditId(null);
//     setEmail('');
//     setFrequency('weekly');
//     setFormats([]);
//   };

//   return (
//     <div>
//       <h2 className="text-2xl font-bold mb-4">
//         Manage Report Recipients
//       </h2>
      
//       {/* Form to add/edit recipient */}
//       <form onSubmit={handleSubmit} className="mb-6 p-4 bg-white rounded shadow">
//         <h3 className="font-semibold mb-2">
//           {editId ? 'Edit Recipient' : 'Add New Recipient'}
//         </h3>
//         <div className="mb-2">
//           <label className="block text-sm font-medium">
//             Email:
//           </label>
//           <input
//             type="email"
//             className="border p-1 rounded w-full"
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             required
//           />
//         </div>
        
//         <div className="mb-2">
//           <label className="block text-sm font-medium">
//             Frequency:
//           </label>
//           <select
//             className="border p-1 rounded w-full"
//             value={frequency}
//             onChange={e => setFrequency(e.target.value)}
//           >
//             <option value="daily">Daily</option>
//             <option value="weekly">Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>
//         </div>
        
//         {/* Formats: use checkboxes for CSV, PDF, Excel */}
//         <div className="mb-2">
//           <label className="block text-sm font-medium">Formats:</label>
//           <div className="flex space-x-4">
//             <label>
//               <input
//                 type="checkbox"
//                 checked={formats.includes('csv')}
//                 onChange={() => handleFormatChange('csv')}
//               /> CSV
//             </label>
//             <label>
//               <input
//                 type="checkbox"
//                 checked={formats.includes('pdf')}
//                 onChange={() => handleFormatChange('pdf')}
//               /> PDF
//             </label>
//             <label>
//               <input
//                 type="checkbox"
//                 checked={formats.includes('xlsx')}
//                 onChange={() => handleFormatChange('xlsx')}
//               /> Excel
//             </label>
//           </div>
//         </div>
        
//         <div className="mt-4">
//           <button
//             type="submit"
//             className="bg-primary text-white px-4 py-2 rounded mr-2"
//           >
//             {editId ? 'Update' : 'Add'}
//           </button>
//           {editId && (
//             <button
//               type="button"
//               onClick={handleCancelEdit}
//               className="bg-gray-400 text-white px-4 py-2 rounded"
//             >
//               Cancel
//             </button>
//           )}
//         </div>
//       </form>

//       <div className="bg-white p-4 rounded shadow">
//         <h3 className="text-xl font-semibold mb-2">Recipients List</h3>
//         {loading ? (
//           <p>Loading recipients...</p>
//         ) : (
//           <table className="min-w-full border text-sm">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="p-2 border">Email</th>
//                 <th className="p-2 border">Frequency</th>
//                 <th className="p-2 border">Formats</th>
//                 <th className="p-2 border">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {recipients.map((recipient) => (
//                 <tr key={recipient._id}>
//                   <td className="p-2 border">{recipient.email}</td>
//                   <td className="p-2 border">{recipient.frequency}</td>
//                   <td className="p-2 border">{(recipient.formats || []).join(', ')}</td>
//                   <td className="p-2 border">
//                     <button
//                       className="mr-2 bg-blue-500 text-white px-2 py-1 rounded"
//                       onClick={() => handleEditClick(recipient)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className="bg-red-500 text-white px-2 py-1 rounded"
//                       onClick={() => handleDelete(recipient._id)}
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//               {recipients.length === 0 && (
//                 <tr>
//                   <td colSpan={4} className="p-2 text-center text-gray-500">
//                     No recipients found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AdminReportRecipients;



// dashboard-frontend/src/components/AdminReportRecipients.jsx
import React, { useEffect, useState } from 'react';
import { fetchJSON } from '../api';

const AdminReportRecipients = () => {
  const [recipients, setRecipients] = useState([]);
  const [loading, setLoading] = useState(true);

  // Form states
  const [email, setEmail] = useState('');
  const [frequency, setFrequency] = useState('weekly');
  const [formats, setFormats] = useState([]); 
  // e.g. user can pick multiple: csv, pdf, xlsx

  // Editing states
  const [editId, setEditId] = useState(null); // the _id of the recipient being edited

  // Fetch the recipients from /api/report-recipients
  const fetchRecipients = async () => {
    try {
      // Using fetchJSON ensures we automatically include Authorization header
      const data = await fetchJSON('/api/report-recipients');
      setRecipients(data);
    } catch (err) {
      console.error('Error fetching recipients:', err);
      alert(err.message || 'Failed to fetch recipients');
    } finally {
      setLoading(false);
    }
  };

  // On component mount, fetch the recipients
  useEffect(() => {
    fetchRecipients();
  }, []);

  // Submit form: either add or update a recipient
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        email,
        frequency,
        formats
      };
      
      if (editId) {
        // Update existing recipient via PUT
        await fetchJSON(`/api/report-recipients/${editId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        alert('Recipient updated successfully');
      } else {
        // Create new recipient via POST
        await fetchJSON('/api/report-recipients', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        alert('Recipient added successfully');
      }

      // Reset form
      setEmail('');
      setFrequency('weekly');
      setFormats([]);
      setEditId(null);

      // Reload the list
      fetchRecipients();
    } catch (err) {
      alert(err.message);
    }
  };

  // Delete a recipient
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this recipient?')) return;
    try {
      await fetchJSON(`/api/report-recipients/${id}`, {
        method: 'DELETE'
      });
      alert('Recipient removed');
      fetchRecipients();
    } catch (err) {
      alert(err.message);
    }
  };

  // Start editing an existing recipient
  const handleEditClick = (recipient) => {
    setEditId(recipient._id);
    setEmail(recipient.email);
    setFrequency(recipient.frequency);
    setFormats(recipient.formats || []);
  };

  // Toggle a format in the formats array
  const handleFormatChange = (format) => {
    if (formats.includes(format)) {
      setFormats(formats.filter(f => f !== format));
    } else {
      setFormats([...formats, format]);
    }
  };

  // Cancel edit mode
  const handleCancelEdit = () => {
    setEditId(null);
    setEmail('');
    setFrequency('weekly');
    setFormats([]);
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">
        Manage Report Recipients
      </h2>

      {/* Form to add/edit recipient */}
      <form onSubmit={handleSubmit} className="mb-6 p-4 bg-white rounded shadow">
        <h3 className="font-semibold mb-2">
          {editId ? 'Edit Recipient' : 'Add New Recipient'}
        </h3>
        <div className="mb-2">
          <label className="block text-sm font-medium">Email:</label>
          <input
            type="email"
            className="border p-1 rounded w-full"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="mb-2">
          <label className="block text-sm font-medium">Frequency:</label>
          <select
            className="border p-1 rounded w-full"
            value={frequency}
            onChange={e => setFrequency(e.target.value)}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        {/* Formats: use checkboxes for CSV, PDF, Excel */}
        <div className="mb-2">
          <label className="block text-sm font-medium">Formats:</label>
          <div className="flex space-x-4">
            <label>
              <input
                type="checkbox"
                checked={formats.includes('csv')}
                onChange={() => handleFormatChange('csv')}
              />{' '}
              CSV
            </label>
            <label>
              <input
                type="checkbox"
                checked={formats.includes('pdf')}
                onChange={() => handleFormatChange('pdf')}
              />{' '}
              PDF
            </label>
            <label>
              <input
                type="checkbox"
                checked={formats.includes('xlsx')}
                onChange={() => handleFormatChange('xlsx')}
              />{' '}
              Excel
            </label>
          </div>
        </div>

        <div className="mt-4">
          <button
            type="submit"
            className="bg-primary text-white px-4 py-2 rounded mr-2"
          >
            {editId ? 'Update' : 'Add'}
          </button>
          {editId && (
            <button
              type="button"
              onClick={handleCancelEdit}
              className="bg-gray-400 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      <div className="bg-white p-4 rounded shadow">
        <h3 className="text-xl font-semibold mb-2">Recipients List</h3>
        {loading ? (
          <p>Loading recipients...</p>
        ) : (
          <table className="min-w-full border text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Email</th>
                <th className="p-2 border">Frequency</th>
                <th className="p-2 border">Formats</th>
                <th className="p-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {recipients.map((recipient) => (
                <tr key={recipient._id}>
                  <td className="p-2 border">{recipient.email}</td>
                  <td className="p-2 border">{recipient.frequency}</td>
                  <td className="p-2 border">{(recipient.formats || []).join(', ')}</td>
                  <td className="p-2 border">
                    <button
                      className="mr-2 bg-blue-500 text-white px-2 py-1 rounded"
                      onClick={() => handleEditClick(recipient)}
                    >
                      Edit
                    </button>
                    <button
                      className="bg-red-500 text-white px-2 py-1 rounded"
                      onClick={() => handleDelete(recipient._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {recipients.length === 0 && (
                <tr>
                  <td colSpan={4} className="p-2 text-center text-gray-500">
                    No recipients found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminReportRecipients;
